import React, { useState, useLayoutEffect, useEffect } from 'react';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import { useLocation, Link, useHistory } from 'react-router-dom';
import { map } from 'lodash';
import { debounce } from 'lodash';
import { RootState } from 'modules';
import { useRecoilState, useRecoilValue } from 'recoil';
import Footer from 'components/base/Footer';
import { HeaderLeft, getMenuTitle } from 'components/base/HeaderLeft';
import { HeaderRight } from 'components/base/HeaderRight';
import { HeaderWrapper, HeaderHeight } from 'components/base/styles';
import IntroduceQuizProcess from 'components/learning/quiz/components/parts/IntroduceQuizProcess';
import { changePrimaryField } from 'libs/api/user';
import {
  quizDetailPageHeightState,
  quizDetailPageWidthState,
  isPageOpenedState,
} from 'modules/learning/recoilState';
import { TChangePrimaryField } from 'modules/user';
import { CWindowWidth } from 'constants/base.const';
import { CMentoringFieldType } from 'constants/mentoring.const';
import { EMentoringField } from 'enums/mentoring.enum';
import { Layout, Col, Row, Drawer, Breadcrumb, Dropdown, Menu } from 'antd';
import { CaretDownOutlined } from '@ant-design/icons';
import styled from 'styled-components';
import { device } from 'GlobalStyles';
import MenuSource from 'assets/icons/menu.webp';
import LogoSource from 'assets/images/logos/logo.svg';
import { Helmet } from 'react-helmet-async';

const { Header, Content } = Layout;

export const LogoImage = () => {
  const history = useHistory();

  return <CSLogoImage alt='logo' src={LogoSource} onClick={() => history.push('/')} />;
};

const CSLogoImage = styled.img`
  width: 150px;
  margin-right: 50px;
  cursor: pointer;

  @media screen and ${device.md} {
    width: 133px;
    margin-right: 20px;
  }
`;

export const KaitusBaseTemplate = ({ children }: { children: React.ReactNode }) => {
  const location = useLocation();
  const [visible, setVisible] = useState(false);
  const currentUser = useSelector((state: RootState) => state.user.current_user, shallowEqual);
  //유저의 프라이버리 필드가 디폴트
  const [currentField, setCurrentField] = useState(currentUser?.primary_field);

  //윈도우 사이즈에 따라 width, height 변경시켜주는 커스텀 훅
  const [width, height] = useWindowSize();
  //IntroduceQuizProcess 컴포넌트에서 window 사이즈에 따라 height 변경시켜주기 위해
  const [heightSize, setHeightSize] = useRecoilState(quizDetailPageHeightState);
  const [widthSize, setWidthSize] = useRecoilState(quizDetailPageWidthState);
  //도움말 페이지가 열려 있을 때만 window 사이즈 트레킹 해주기 위해
  const isQuizProcessPageOpened = useRecoilValue<boolean>(isPageOpenedState);

  function useWindowSize() {
    const [size, setSize] = useState([0, 0]);

    useLayoutEffect(() => {
      const updateSize = debounce(() => {
        setSize([window.innerWidth, window.innerHeight]);
      }, 100);
      window.addEventListener('resize', updateSize);
      updateSize();
      return () => window.removeEventListener('resize', updateSize);
    }, []);

    return size;
  }

  useEffect(() => {
    setHeightSize(height);
  }, [height]);

  useEffect(() => {
    setWidthSize(width);
  }, [width]);

  return (
    <Layout>
      <Helmet>
          <meta charSet="utf-8" />
          <title>Kaitus Assessment</title>
      </Helmet>
      <HeaderWrapper isQuizProcessPageOpened={isQuizProcessPageOpened}>
        {/* 퀴즈 컴포넌트 안에서 혹은 baseTemplate 밖에서 컴포넌트있으면 absolute 위치가 그 기준에 맞게 먹기 때문에 Header(내브바)에 붇어있도록 */}
        {location.pathname.includes('case/quiz/view') && isQuizProcessPageOpened && <IntroduceQuizProcess />}
        <Header></Header>
      </HeaderWrapper>
      <Content>
        <div
          style={{
            margin: '0px auto',
            // marginTop: isQuizProcessPageOpened
            //   ? '0px'
            //   : getMenuTitle(location.pathname)[0]
            //   ? `${HeaderHeight + 25}px`
            //   : `${HeaderHeight}px`,
            marginTop: getMenuTitle(location.pathname)[0] ? `${HeaderHeight + 25}px` : `${HeaderHeight}px`,
            padding: '0px',
          }}
        >
          {children}
        </div>
      </Content>
    </Layout>
  );
};
